module.exports = __webpack_public_path__ + "static/media/cross-device-mockup-16x10-desktop@3x.b632e8fc.png";